export const lineOverviewTranslations = {
  // Connect gate
  title: "LINE OA",
  connectTitle: "เชื่อมต่อ LINE Messaging API",
  connectDesc:
    "เชื่อมต่อ LINE Messaging API ในการตั้งค่าหน้าร้าน เพื่อเข้าใช้งานแดชบอร์ดนี้",
  connectCta: "ไปที่การตั้งค่า",

  // Header
  switchOA: "สลับ LINE OA",
  friends: "เพื่อน",
  lineSettings: "ตั้งค่า LINE",

  // Error
  loadError: "โหลดข้อมูลจาก LINE ไม่สำเร็จ ลองใหม่อีกครั้ง",
  retry: "ลองใหม่",

  // Hero cards
  broadcasts: "บรอดแคสต์",
  broadcastsDesc: "ส่งข้อความถึงเพื่อนทุกคนของคุณ",
  sendBroadcast: "ส่งบรอดแคสต์",
  campaigns: "แคมเปญ",
  campaignsDesc: "เจาะกลุ่มลูกค้าตามประวัติการสั่งซื้อแล้วส่งข้อความ",
  createCampaign: "สร้างแคมเปญ",

  // Friends insights
  friendsTitle: "เพื่อน",
  audience: "กลุ่มเป้าหมาย",
  trends: "แนวโน้ม",
  period7d: "7 วัน",
  period30d: "30 วัน",
  period90d: "90 วัน",
  metric: "ตัวชี้วัด",
  change: "เปลี่ยนแปลง",
  trend: "แนวโน้ม",
  metricFriends: "เพื่อน",
  metricTargetReach: "การเข้าถึงเป้าหมาย",
  metricNewFollowers: "ผู้ติดตามใหม่",
  notEnoughData:
    "ยังมีข้อมูลผู้ติดตามไม่เพียงพอ — ข้อมูลเชิงลึกจะแสดงเมื่อบัญชีของคุณมีความเคลื่อนไหว",

  // Broadcasts panel
  yourBroadcasts: "บรอดแคสต์ของคุณ",
  messagesThisMonth: "ข้อความในเดือนนี้",
  sendBroadcastShort: "ส่งบรอดแคสต์",
  pastBroadcast: "บรอดแคสต์ที่ผ่านมา",
  delivered: "ส่งแล้ว",
  opens: "เปิดอ่าน",
  uniqueClicks: "คลิก (ไม่ซ้ำ)",
  imageMessage: "ข้อความรูปภาพ",
  opensClicksNote:
    "ยอดเปิดอ่านและคลิกมาจาก LINE อาจใช้เวลาสองสามชั่วโมงจึงจะแสดงหลังส่ง",
  noBroadcasts:
    "ยังไม่มีการส่งบรอดแคสต์ ส่งครั้งแรกเพื่อเข้าถึงเพื่อนทุกคนของคุณ",

  // Automated notifications
  automatedNotifications: "การแจ้งเตือนอัตโนมัติ",
  automatedNotificationsDescPre:
    "ข้อความที่ร้านของคุณส่งถึงลูกค้าโดยอัตโนมัติ เปิด/ปิดได้ที่",
  automatedNotificationsDescPost: "",
  on: "เปิด",
  off: "ปิด",
  lastSent: "ส่งล่าสุด",
  noneSentYet: "ยังไม่ได้ส่ง",
  sent: "ส่งแล้ว",
  thisMonthShort: "เดือนนี้",

  // Notification types
  notif_order_confirmation: "ยืนยันคำสั่งซื้อ",
  notif_order_confirmation_desc: "เมื่อมีคำสั่งซื้อใหม่",
  notif_payment_confirmation: "ยืนยันการชำระเงิน",
  notif_payment_confirmation_desc: "เมื่อได้รับการชำระเงิน",
  notif_payment_reminder: "เตือนชำระเงิน",
  notif_payment_reminder_desc: "เมื่อคำสั่งซื้อรอการชำระเงิน",
  notif_shipment: "ติดตามการจัดส่ง",
  notif_shipment_desc: "เมื่อคำสั่งซื้อถูกจัดส่งแล้ว",
  notif_booking_confirmation: "ยืนยันการจอง",
  notif_booking_confirmation_desc: "เมื่อมีการสร้างการจอง",

  // Payment reminders
  paymentReminders: "การเตือนชำระเงิน",
  remindersSent: "ส่งการเตือนแล้ว",
  clicks: "คลิก",
  paidAfter: "ชำระหลังเตือน",
  conversionPct: "อัตราการชำระ %",

  // Targeted campaigns (send history + stats)
  campaignSectionTitle: "แคมเปญเจาะจง",
  campaignSectionDesc: "ข้อความที่ส่งถึงกลุ่มลูกค้าที่เลือกไว้",
  campaignStatTotalSends: "จำนวนครั้งที่ส่ง",
  campaignStatTotalDelivered: "ส่งถึงทั้งหมด",
  campaignStatSuccessful: "ส่งสำเร็จ",
  campaignHistoryTitle: "ประวัติการส่ง",

  // Secondary actions
  richMenus: "ริชเมนู",
  richMenusDesc: "สร้างเมนูด้านล่างให้เพื่อนของคุณ",
  audienceDesc: "ดูโปรไฟล์ผู้ติดตามของคุณ",

  // Store switcher
  switchOALong: "สลับ LINE OA / ร้านค้า",
  primary: "หลัก",
}
